
var modal = document.querySelector(".size_modal");
var trigger = document.querySelector(".size_guide_button");
var closeButton = document.querySelector(".close-size-button");

function toggleModal() {
    modal.classList.toggle("show-size-modal");
    document.body.classList.toggle("modal-open");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

if(trigger) trigger.addEventListener("click", toggleModal);
if(closeButton) closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


// let findWislistBtnInterval = setInterval(wishListBtn, 500); 
// function wishListBtn() {
//   if(document.querySelector("wishlist-button-block").querySelector('[type="button"]')){    
//     document.querySelector(".wishlist_button").addEventListener("click",function(Element){
//       Element.currentTarget.classList.toggle('active')
//       document.querySelector("wishlist-button-block").querySelector('[type="button"]').click();
//     })  
//     if(document.querySelector("wishlist-button-block").querySelector('[type="button"]').getAttribute('aria-label') == 'In Wishlist'){
//       document.querySelector(".wishlist_button").classList.add('active');
//     }
//      clearInterval(findWislistBtnInterval)
//   }
// }

let findStoreAvailabilityInterval = setInterval(StoreAvailability, 800);
function StoreAvailability() {
if(document.querySelector('.slideout__trigger-store-availability')){
  document.querySelector('.slideout__trigger-store-availability').addEventListener('click',function(e){
    e.preventDefault();
    console.log(document.querySelector('.store-availabilities-modal'))
    if(document.querySelector('.store-availabilities-modal')) document.querySelector('.store-availabilities-modal').classList.toggle('active-store');
  })  
  clearInterval(findStoreAvailabilityInterval)
}
}

function setSectionHeight() {
  let section = document.querySelector('.header-group'); 
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--header-group-height', sectionHeight);
}

setSectionHeight();

window.addEventListener('resize', setSectionHeight);
window.addEventListener('scroll', setSectionHeight);


function setWindowWidth() {
  let screenWidth = window.innerWidth;
  document.documentElement.style.setProperty('--window-width', `${screenWidth}px`);
}
setWindowWidth();
window.addEventListener('resize', setWindowWidth);